var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBranch = function SvgBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 3.625a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m1.875-.75c0 .84-.55 1.55-1.312 1.789V7a2.8 2.8 0 0 1 1.687-.562h2.25c.933 0 1.688-.755 1.688-1.688v-.086A1.874 1.874 0 0 1 10.375 1a1.875 1.875 0 0 1 .563 3.664v.086a2.81 2.81 0 0 1-2.813 2.813h-2.25c-.933 0-1.687.755-1.687 1.687v.087A1.874 1.874 0 0 1 3.625 13a1.874 1.874 0 0 1-.562-3.663V4.664A1.874 1.874 0 0 1 3.625 1C4.661 1 5.5 1.84 5.5 2.875m5.625 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-7.5 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })));
};
export default SvgBranch;